const codeChecker = (value, t) => {
  const { codes, name } = value;

  if (name === t('flightstatus.search.nocity')) return false;
  else if (codes) return true;
  else return false;
};

export default codeChecker;
